import { AccessInfo, User, UserNotificationsConfig } from 'src/interfaces/user'
import { State } from '../reducers/types'
import { Customer } from 'src/interfaces/customer'

export const getUser = (state: State): User | null => state.user.user

export const getAccessInfo = (state: State): AccessInfo | null => state.user.accessInfo

export const getHasAccessToMarkets = (state: State): boolean => {
  const accessInfo = getAccessInfo(state)

  return accessInfo?.allMarkets || !!accessInfo?.markets.length
}

export const getIsUserInitialized = (state: State): boolean => state.user.isUserInitialized

export const getPartnerId = (state: State): string | null => {
  const user = getUser(state)

  if (!user) {
    return null
  }

  return user.partner.id
}

export const getPartner = (state: State): Customer | null => {
  const user = getUser(state)

  if (!user) {
    return null
  }

  return user.partner
}

export const getUserNotificationConfig = (state: State): UserNotificationsConfig | null =>
  state.user.userNotificationConfig

export const getIsCustomerOnboarded = (state: State): boolean => {
  const user = getUser(state)

  if (!user) {
    return false
  }

  return !user?.partner?.isMasterContractor || !!user?.partner?.masterContractorOnboardedAt
}

export const getIsMasterContractor = (state: State): boolean => {
  const user = getUser(state)

  if (!user) {
    return false
  }

  return !!user.partner.isMasterContractor
}
